<div>
  <div class="row g-4 pb-4 pt-4 align-items-stretch">
    <!-- Column 1: Tickets Group (New + In Progress) - Side by Side -->
    <div class="col-lg-8 col-md-8 col-12 d-flex">
      <div class="widget-group widget-group--tickets h-100 w-100 d-flex flex-column">
        <div class="widget-group__header">
          <span class="widget-group__label">Tickets</span>
          <span class="widget-group__date-range">
            This Week
            <kendo-svg-icon
              kendoTooltip
              [icon]="infoCircleIcon"
              title="New: tickets opened Monday through today. In Progress: all active tickets (not time-bound). Closed: tickets resolved this week."
              class="widget-group__info-icon"
            ></kendo-svg-icon>
          </span>
        </div>
        <div class="widget-group__content d-flex flex-row gap-3">
          <app-new-tickets-widget class="widget-equal"></app-new-tickets-widget>
          <app-progress-tickets-widget class="widget-equal"></app-progress-tickets-widget>
          <app-closed-today-widget class="widget-equal"></app-closed-today-widget>
        </div>
      </div>
    </div>

    <!-- Column 2: SOC Metrics Group (MTTD + TPR) - Side by Side -->
    <div class="col-lg-4 col-md-6 col-12 d-flex">
      <div class="widget-group widget-group--soc h-100 w-100 d-flex flex-column">
        <div class="widget-group__header">
          <span class="widget-group__label">SOC Performance</span>
          <span class="widget-group__date-range">
            Past 30 Days
            <kendo-svg-icon
              kendoTooltip
              [icon]="infoCircleIcon"
              title="Rolling 30-day window for statistical stability. MTTD = Mean Time to Disposition, TPR = True Positive Rate."
              class="widget-group__info-icon"
            ></kendo-svg-icon>
          </span>
        </div>
        <div class="widget-group__content d-flex flex-row gap-3">
          <app-mttd-widget class="widget-equal"></app-mttd-widget>
          <app-tpr-widget class="widget-equal"></app-tpr-widget>
        </div>
      </div>
    </div>
  </div>
  <div class="row p-4 tile-container">
    <div class="col col-md-12 tile">
      <h5>
        Data Connection Issues
        <kendo-svg-icon
          kendoTooltip
          [icon]="infoCircleIcon"
          title="Data sources that appear to be down or offline"
        ></kendo-svg-icon>
      </h5>
      <app-connector-status></app-connector-status>
    </div>
  </div>
  <div class="row p-4 tile-container">
    <div class="col col-md-7 tile"><app-ticket-trends></app-ticket-trends></div>
    <div class="col tile"><app-advisories-main></app-advisories-main></div>
  </div>
  <div class="row p-4 tile-container">
    <div class="col col-md-7 tile"><app-quick-links></app-quick-links></div>
  </div>
</div>
